import { Auth, API } from "aws-amplify";
import axios from "axios";
import * as qs from "qs";

const ADMIN_API_BASE_URL = process.env.MAIN_API;

class AdminService {
  async addToGroup(username, group) {
    let apiName = "AdminQueries";
    let path = "/addUserToGroupAdmin";
    let myInit = {
      body: {
        username: `${username}`,
        groupname: `${group}`,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `${(await Auth.currentSession())
          .getAccessToken()
          .getJwtToken()}`,
      },
    };
    return await API.post(apiName, path, myInit);
  }

  async removeFromGroup(username, groupName) {
    let apiName = "AdminQueries";
    let path = "/removeUserFromGroup";
    let myInit = {
      body: {
        username: `${username}`,
        groupname: `${groupName}`,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `${(await Auth.currentSession())
          .getAccessToken()
          .getJwtToken()}`,
      },
    };
    return await API.post(apiName, path, myInit);
  }

  async listUsersInGroup(groupName) {
    // let nextToken;

    let apiName = "AdminQueries";
    let path = "/listUsersInGroupAdmin";
    let myInit = {
      queryStringParameters: {
        groupname: `${groupName}`,
        limit: "60",
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `${(await Auth.currentSession())
          .getAccessToken()
          .getJwtToken()}`,
      },
    };
    // const { NextToken, ...rest } =   API.get(apiName, path, myInit);
    // nextToken = NextToken;
    return await API.get(apiName, path, myInit);
  }

  async getUser(username) {
    // let nextToken;

    let apiName = "AdminQueries";
    let path = "/getUser";
    let myInit = {
      queryStringParameters: {
        username: `${username}`,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `${(await Auth.currentSession())
          .getAccessToken()
          .getJwtToken()}`,
      },
    };

    return await API.get(apiName, path, myInit);
  }

  async listAllUserGroups(username) {
    // let nextToken;

    let apiName = "AdminQueries";
    let path = "/listGroupsForUser";
    let myInit = {
      queryStringParameters: {
        username: `${username}`,
        limit: "60",
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `${(await Auth.currentSession())
          .getAccessToken()
          .getJwtToken()}`,
      },
    };
    // const { NextToken, ...rest } =   API.get(apiName, path, myInit);
    // nextToken = NextToken;
    return await API.get(apiName, path, myInit);
  }

  async allUsers() {
    // let nextToken;
    let apiName = "AdminQueries";
    let path = "/listUsers";
    let myInit = {
      queryStringParameters: {
        limit: "60",
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `${(await Auth.currentSession())
          .getAccessToken()
          .getJwtToken()}`,
      },
    };
    // const { NextToken, ...rest } =   API.get(apiName, path, myInit);
    // nextToken = NextToken;
    return await API.get(apiName, path, myInit);
  }

  async createBulletin(data) {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    let body = data;

    return await axios.post(
      ADMIN_API_BASE_URL + "/bulletin/update-bulletin-info",
      body,
      myInit
    );
  }

  async getBulletinData(page) {
    let myInit = {
      params: {
        view: `${page}`,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.get(
      ADMIN_API_BASE_URL + "/bulletin/bulletin-info",
      myInit
    );
  }
  async getUserProfileData() {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.get(
      ADMIN_API_BASE_URL + "/user/current-user-info",
      myInit
    );
  }

  async getAllUsersDetails() {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    return await axios.get(ADMIN_API_BASE_URL + "/admin/all/users", myInit);
  }
  async editUserAccessAndRoles(body) {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    const response = await axios.post(
      ADMIN_API_BASE_URL + "/admin/all/clients_projects",
      body,
      myInit
    );
    return response.data;
  }

  async getAllClientsProjects() {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.get(
      ADMIN_API_BASE_URL + "/admin/all/clients_projects",
      myInit
    );
  }
  async getAllRoles() {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.get(ADMIN_API_BASE_URL + "/admin/roles", myInit);
  }
  async getRoleCreationData(role) {
    let myInit = {
      params: {
        role,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    return await axios.get(
      ADMIN_API_BASE_URL + "/admin/existing_roles_subservices",
      myInit
    );
  }
  async createNewRole(role, group, subservices) {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    const body = { role, group, subservices };

    return await axios.post(
      ADMIN_API_BASE_URL + "/admin/role/create",
      body,
      myInit
    );
  }
  async updateRole(role, group, subservices) {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    const body = { role, group, subservices };

    return await axios.post(
      ADMIN_API_BASE_URL + "/admin/role/update",
      body,
      myInit
    );
  }

  async getUserRoleAccess(username, group) {
    let myInit = {
      params: {
        username,
        group,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.get(
      ADMIN_API_BASE_URL + "/admin/user_roles_subservices",
      myInit
    );
  }

  async updateUserRoleAccess(body) {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.post(
      ADMIN_API_BASE_URL + "/admin/user_access/update",
      body,
      myInit
    );
  }

  async getDashboardFilterdData(client, project, start_date, end_date) {
    let myInit = {
      params: {
        client: `${client}`,
        projects: project,
        start_date: start_date,
        end_date: end_date,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.get(
      ADMIN_API_BASE_URL + "/dashboard/samples-counts-filtered",
      myInit
    );
  }

  async getSubjectFilterdData(client, project, start_date, end_date) {
    let myInit = {
      params: {
        client: `${client}`,
        projects: project,
        start_date: start_date,
        end_date: end_date,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.get(
      ADMIN_API_BASE_URL + "/dashboard/subject-counts-filtered",
      myInit
    );
  }

  async getDashboardData() {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.get(
      ADMIN_API_BASE_URL + "/dashboard/samples-counts",
      myInit
    );
  }

  async getDefaultSubjectMetricsData() {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.get(
      ADMIN_API_BASE_URL + "/dashboard/subject-metrics",
      myInit
    );
  }

  async setDefault(payload) {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    let body = payload;
    return await axios.post(
      ADMIN_API_BASE_URL + "/dashboard/add_default_client_projects",
      body,
      myInit
    );
  }
   
  async getCustomDashboardData(client, project , interval) {
    const params = {
      client: client,
      project: project,
      interval: interval,
    };
     
    let myInit = {
      params: params,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
 
    return await axios.get(
      ADMIN_API_BASE_URL + "/dashboard/custom-dashboard-data",
      myInit
    );
  }
  
  async getCustomDashboardDataFile(client, project,interval , sourceType= "blood" ) {
    const params = {
      client: client,
      project: project,
      interval: interval,
      source_type: sourceType,
    };

    let myInit = {
      params: params,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.get(
      ADMIN_API_BASE_URL + "/dashboard/get-custom-dashboard-data-file",
      myInit
    );
  }

  async getUnusableVolumeSubjectCodes(client, project, targetDate) {
    const params = {
      client: client,
      project: project,
      target_date: targetDate,
    };

    let myInit = {
      params: params,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.get(
      ADMIN_API_BASE_URL + "/dashboard/get-unusable-volume-subject-codes",
      myInit
    );
  }

  async getSamplesExpiredBeforeReceived(client, project, targetDate) {
    const params = {
      client: client,
      project: project,
      target_date: targetDate,
    };

    let myInit = {
      params: params,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.get(
      ADMIN_API_BASE_URL + "/dashboard/get_no_of_kits_expired",
      myInit
    );
  }

  async getSamplesForPlasmaGrade(client, project, targetDate) {
    const params = {
      client: client,
      project: project,
      target_date: targetDate,
    };

    let myInit = {
      params: params,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.get(
      ADMIN_API_BASE_URL + "/dashboard/get-samples-for-plasma-grade",
      myInit
    );
  }

  async getSamplesForCollectToFreezeTat(client, project, targetDate) {
    const params = {
      client: client,
      project: project,
      target_date: targetDate,
    };

    let myInit = {
      params: params,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.get(
      ADMIN_API_BASE_URL + "/dashboard/get-samples-for-collect-to-freeze-tat",
      myInit
    );
  }

  async getSamplesForCollectToReceived(client, project, targetDate) {
    const params = {
      client: client,
      project: project,
      target_date: targetDate,
    };
 
    let myInit = {
      params: params,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
 
    return await axios.get(
      ADMIN_API_BASE_URL + "/dashboard/get-samples-for-collect-to-received",
      myInit
    );
  }

  async getSampleProcessingDeviationCodes(client, project, targetDate) {
    const params = {
      client: client,
      project: project,
      target_date: targetDate,
    };

    let myInit = {
      params: params,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.get(
      ADMIN_API_BASE_URL + "/dashboard/get-sample-processing-deviation-codes",
      myInit
    );
  }
  
  async getUrineLowVolumeSubjectCodes(client, project, targetDate) {
    const params = { client, project, target_date: targetDate };
    let myInit = {
      params,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
      },
    };
    return await axios.get(ADMIN_API_BASE_URL + "/dashboard/get-urine-low-volume-subject-codes", myInit);
  }
 
  async getUrineHighVolumeSubjectCodes(client, project, targetDate) {
    const params = { client, project, target_date: targetDate };
    let myInit = {
      params,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
      },
    };
    return await axios.get(ADMIN_API_BASE_URL + "/dashboard/get-urine-high-volume-subject-codes", myInit);
  }
 
  async getUrineKitExpirationDateLessThanReceived(client, project, targetDate) {
    const params = { client, project, target_date: targetDate };
    let myInit = {
      params,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
      },
    };
    return await axios.get(ADMIN_API_BASE_URL + "/dashboard/get-urine-kit-expiration-date-less-than-received", myInit);
  }
 
  async getUrineViabilityTat(client, project, targetDate) {
    const params = { client, project, target_date: targetDate };
    let myInit = {
      params,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
      },
    };
    return await axios.get(ADMIN_API_BASE_URL + "/dashboard/get-urine-viability-tat", myInit);
  }
 
  async getUrineShipmentToSampledTat(client, project, targetDate) {
    const params = { client, project, target_date: targetDate };
    let myInit = {
      params,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
      },
    };
    return await axios.get(ADMIN_API_BASE_URL + "/dashboard/get-urine-shipment-to-sampled-tat", myInit);
  }
 
  async getUrineProcessingTat(client, project, targetDate) {
    const params = { client, project, target_date: targetDate };
    let myInit = {
      params,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
      },
    };
    return await axios.get(ADMIN_API_BASE_URL + "/dashboard/get-urine-processing-tat", myInit);
  }
 
  async getUrineSampleProcessingDeviationCodes(client, project, targetDate) {
    const params = { client, project, target_date: targetDate };
    let myInit = {
      params,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
      },
    };
    return await axios.get(ADMIN_API_BASE_URL + "/dashboard/get-urine-sample-processing-deviation-codes", myInit);
  }
 
  async getUrineDelayAddingStreckBuffer(client, project, targetDate) {
    const params = { client, project, target_date: targetDate };
    let myInit = {
      params,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
      },
    };
    return await axios.get(ADMIN_API_BASE_URL + "/dashboard/get-urine-delay-adding-streck-buffer", myInit);
  }
}
 
export default new AdminService();